export default __webpack_public_path__ + "static/media/watermelon.d54926d6.jpg";